module.exports = __webpack_public_path__ + "img/barraganm.3428f9b3.png";